import React from "react";
import clsx from "clsx";

import ImgSrc from "./../../i/icons/avatar.svg";

const Avatar = (props) => {
  const { size, initials } = props;

  let style = clsx("avatar", {
    "avatar--sm": size === "sm",
    "avatar--md": size === "md",
    "avatar--lg": size === "lg",
    "avatar--initials": initials,
  });

  if (initials) {
    return <span className={style}>{initials}</span>;
  } else {
    return <img className={style} src={ImgSrc} alt="Avatar" />;
  }
};

export default Avatar;
